import { formatSalesValue } from './../../../utils/formatUtils';

const BeverageCosting = ({ beverageData, calculatePercentage, totalBeverageItems, missingBeverageItemsCount, beverageAccuracy }) => {
    return (
        <div className="border p-2 space-y-16">
            <div>
                <div className="font-semibold mb-2 text-lg text-center">BEVERAGE</div>

                <div className="rounded-md border overflow-x-auto max-h-[400px] mb-4">
                    <table className="min-w-ful overflow-y-auto divide-y divide-gray-200 text-sm text-center">
                        <thead className="bg-gray-100">
                            <tr>
                                <th className="px-3 py-2 text-xs font-medium text-gray-700 uppercase tracking-wider">Item Name</th>
                                <th className="px-3 py-2 text-xs font-medium text-gray-700 uppercase tracking-wider">Qty</th>
                                <th className="px-3 py-2 text-xs font-medium text-gray-700 uppercase tracking-wider">Sale</th>
                                <th className="px-3 py-2 text-xs font-medium text-gray-700 uppercase tracking-wider">Unit Cost</th>
                                <th className="px-3 py-2 text-xs font-medium text-gray-700 uppercase tracking-wider">CP (%)</th>
                                <th className="px-3 py-2 text-xs font-medium text-gray-700 uppercase tracking-wider">Total Cost</th>
                            </tr>
                        </thead>
                        <tbody className="bg-white divide-y divide-gray-100">
                            {beverageData?.sales_summary?.items_sold?.map((item, i) => (
                                <tr key={i} className="hover:bg-gray-50">
                                    <td className="px-3 py-2">{item.ItemName}</td>
                                    <td className="px-3 py-2">{item.qty}</td>
                                    <td className="px-3 py-2">{formatSalesValue(item.total_sale)}</td>
                                    <td className="px-3 py-2">{formatSalesValue(item.unit_cost)}</td>
                                    <td className="px-3 py-2">
                                        {item.unit_cost && item.total_sale && item.qty ?
                                            calculatePercentage(item.unit_cost, parseFloat(item.total_sale) / parseFloat(item.qty)) :
                                            "N/A"}
                                    </td>
                                    <td className="px-3 py-2">{formatSalesValue(item.total_cost)}</td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>

                <div className="mt-4 grid grid-cols-2 gap-32 font-semibold px-2">
                    <div>
                        <div className="grid grid-cols-2 gap-2 items-center">
                            <label className="mr-2">Total items:</label>
                            <input
                                type="text"
                                readOnly
                                value={totalBeverageItems}
                                className="border p-1 rounded w-full font-semibold text-center"
                            />

                            <label className="mr-2">Missing items:</label>
                            <input
                                type="text"
                                readOnly
                                value={missingBeverageItemsCount}
                                className="border p-1 rounded w-full font-semibold text-center"
                            />

                            <label className="mr-2">Accuracy:</label>
                            <input
                                type="text"
                                readOnly
                                value={`${beverageAccuracy}%`}
                                className={`border p-1 rounded w-full font-semibold text-center ${beverageAccuracy < 80
                                    ? 'bg-red-200 text-red-800'
                                    : beverageAccuracy >= 80 && beverageAccuracy <= 90 ? 'bg-yellow-200 text-yellow-800' :
                                        'bg-green-200 text-green-800'
                                    }`}
                            />
                        </div>
                    </div>

                    <div className="grid grid-cols-2 gap-2 items-center">
                        <label className="mr-2">Gross Cost:</label>
                        <input
                            type="text"
                            readOnly
                            value={formatSalesValue(beverageData?.sales_summary?.gross_cost)}
                            className="border p-1 rounded w-full font-semibold text-center"
                        />

                        <label className="mr-2">Gross Sale:</label>
                        <input
                            type="text"
                            readOnly
                            value={formatSalesValue(beverageData?.sales_summary?.gross_sale)}
                            className="border p-1 rounded w-full font-semibold text-center"
                        />

                        <label className="mr-2">Gross Cost %:</label>
                        <input
                            type="text"
                            readOnly
                            value={beverageData?.sales_summary?.gross_cost_percent ? beverageData.sales_summary.gross_cost_percent + "%" : "0.00%"}
                            className="border p-1 rounded w-full font-semibold text-center"
                        />

                        <label className="mr-2">Discount:</label>
                        <input
                            type="text"
                            readOnly
                            value={formatSalesValue(beverageData?.sales_summary?.discount)}
                            className="border p-1 rounded w-full font-semibold text-center"
                        />

                        <label className="mr-2">Complementary:</label>
                        <input
                            type="text"
                            readOnly
                            value={formatSalesValue(beverageData?.sales_summary?.complemnetary)}
                            className="border p-1 rounded w-full font-semibold text-center"
                        />

                        <label className="mr-2">Net Sale:</label>
                        <input
                            type="text"
                            readOnly
                            value={formatSalesValue(beverageData?.sales_summary?.net_sale)}
                            className="border p-1 rounded w-full font-semibold text-center"
                        />

                        <label className="mr-2">Net Cost % from Sales:</label>
                        <input
                            type="text"
                            readOnly
                            value={beverageData?.sales_summary?.net_cost_percent ? beverageData.sales_summary.net_cost_percent + "%" : "0.00%"}
                            className="border p-1 rounded w-full font-semibold text-center"
                        />
                    </div>
                </div>
            </div>

            <div>
                <h3 className="font-semibold text-center text-lg mb-2">BEVERAGE ITEMS PURCHASED</h3>

                <div className="rounded-md border overflow-x-auto max-h-[400px]">
                    <table className="min-w-full divide-y divide-gray-200 text-sm text-center">
                        <thead className="bg-gray-100">
                            <tr>
                                <th className="px-3 py-2 text-xs font-medium text-gray-700 uppercase tracking-wider">ITEM</th>
                                <th className="px-3 py-2 text-xs font-medium text-gray-700 uppercase tracking-wider">AMT</th>
                                <th className="px-3 py-2 text-xs font-medium text-gray-700 uppercase tracking-wider">UOM</th>
                                <th className="px-3 py-2 text-xs font-medium text-gray-700 uppercase tracking-wider">RATE</th>
                                <th className="px-3 py-2 text-xs font-medium text-gray-700 uppercase tracking-wider">TOTAL</th>
                            </tr>
                        </thead>
                        <tbody className="bg-white divide-y divide-gray-100">
                            {beverageData?.purchase_summary?.items?.map((item, i) => (
                                <tr key={i} className="hover:bg-gray-50">
                                    <td className="px-3 py-2">{item.item_name}</td>
                                    <td className="px-3 py-2">{formatSalesValue(item.quantity)}</td>
                                    <td className="px-3 py-2">{item.uom}</td>
                                    <td className="px-3 py-2">{formatSalesValue(item.rate)}</td>
                                    <td className="px-3 py-2">{formatSalesValue(item.total)}</td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>

                <div className="mt-2 p-1 flex gap-3 justify-end items-center mb-3">
                    <label className="mr-2 font-semibold">Total Beverage Purchase:</label>
                    <input
                        type="text"
                        readOnly
                        value={formatSalesValue(beverageData?.purchase_summary?.total_purchase)}
                        className="border p-1 rounded w-40 font-semibold text-center"
                    />
                </div>
            </div>
        </div>
    )
}

export default BeverageCosting